module.exports = __webpack_public_path__ + "static/media/project2.250ded84.png";